import { useState } from 'react'
import pick from 'lodash-es/pick'

import { updateRequestProfile } from '../../../../api'
import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../constants/common'
import { useNotification } from '../../../../hooks'
import { getEntityActionTypeSelectOptionsEditOnly } from '../../../Entity'
import {
  getRequestEditManagerModalInitialValues,
  RequestEditManagerModal,
} from '../../../Request'
import { getBirdviewRequestAssignee } from '../../DashboardBirdview.utils.rows'
import { checkIsBirdviewDashboardReload } from '../../DashboardBirdview.utils.sections'

import {
  getBirdviewAssigneeName,
  getBirdviewAssignPayload,
} from './useBirdviewRequestQuickActions.utils'

export function useBirdviewRequestQuickActions({ onCloseModal, onSetModal }) {
  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const [assigneeById, setAssigneeById] = useState(EMPTY_OBJECT)
  const [pendingIds, setPendingIds] = useState(EMPTY_LIST)

  function addPendingId(id) {
    setPendingIds(ids => [...ids, id])
  }

  function removePendingId(id) {
    setPendingIds(ids => ids.filter(pendingId => pendingId !== id))
  }

  // A request shows up in several sections, so only a dashboard-wide reload
  // refreshes every row an override stands in for.
  function handleResetAssignee(sectionKey) {
    if (checkIsBirdviewDashboardReload(sectionKey)) {
      setAssigneeById(byId => pick(byId, pendingIds))
    }
  }

  function getHandleSubmitAssign({ item, onReload }) {
    return ({ payload, values }) => {
      const previousAssignee = getBirdviewRequestAssignee(item, assigneeById)

      onCloseModal()
      addPendingId(item.id)
      setAssigneeById(byId => ({
        ...byId,
        [item.id]: getBirdviewAssigneeName(values),
      }))

      updateRequestProfile({
        data: getBirdviewAssignPayload(payload),
        id: item.id,
      })
        .then(() => {
          handleAddSuccessNotification('Notification.CommonTitleSavedKey')
        })
        .catch(() => {
          setAssigneeById(byId => ({ ...byId, [item.id]: previousAssignee }))
          handleAddErrorNotification('Error.CommonApiRequestFailKey')
          onReload()
        })
        .finally(() => {
          removePendingId(item.id)
        })
    }
  }

  function handleAssign(item, onReload) {
    onSetModal(
      <RequestEditManagerModal
        itemAction
        formFieldsProps={{
          actionTypes: getEntityActionTypeSelectOptionsEditOnly(),
        }}
        id={item.id}
        initialValues={getRequestEditManagerModalInitialValues({
          itemAction: true,
        })}
        onClose={onCloseModal}
        onSubmit={getHandleSubmitAssign({ item, onReload })}
      />
    )
  }

  return {
    assigneeById,
    handleAssign,
    handleResetAssignee,
    pendingIds,
  }
}
